export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.969642b4.svg";